module.exports = __webpack_public_path__ + "img/magento-logo.2b62a5ba.svg";